export const TAPPING_DONE_HISTORY_REQUEST = "TAPPING_DONE_HISTORY_REQUEST";
export const TAPPING_DONE_HISTORY_SUCCESS = "TAPPING_DONE_HISTORY_SUCCESS";
export const TAPPING_DONE_HISTORY_FAILED = "TAPPING_DONE_HISTORY_FAILED";